<template>
  <div class="stmp-app">
    <MarketplaceDashboard />
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import MarketplaceDashboard from './components/MarketplaceDashboard.vue';
import { provideApiConfig } from './composables/useApi';

type Props = {
  apiCreate: string;
  apiUpdate: string;
  apiDelete: string;
  apiList: string;
  apiListArchived?: string;
  apiUploadImage: string;
  apiDeleteImage: string;
  apiCategorySearch: string;
  apiProductSearch: string;
  apiFeaturesSearch: string;
  apiChatInit?: string;
  apiChatHistory?: string;
  apiChatSend?: string;
  apiChatConversations?: string;
  wsChatUrl?: string;
  apiAddresses?: string;
  apiAddressSetDefault?: string;
  addAddressUrl?: string;
};
const props = defineProps<Props>();
provideApiConfig({
  apiCreate: props.apiCreate,
  apiUpdate: props.apiUpdate,
  apiDelete: props.apiDelete,
  apiList: props.apiList,
  apiListArchived: props.apiListArchived,
  apiUploadImage: props.apiUploadImage,
  apiDeleteImage: props.apiDeleteImage,
  apiCategorySearch: props.apiCategorySearch,
  apiProductSearch: props.apiProductSearch,
  apiFeaturesSearch: props.apiFeaturesSearch,
  apiChatInit: props.apiChatInit,
  apiChatHistory: props.apiChatHistory,
  apiChatSend: props.apiChatSend,
  apiChatConversations: props.apiChatConversations,
  wsChatUrl: props.wsChatUrl,
  apiAddresses: props.apiAddresses,
  apiAddressSetDefault: props.apiAddressSetDefault,
  addAddressUrl: props.addAddressUrl,
});
</script>

<style scoped>
.stmp-app {
  padding: 8px 0;
}
</style>
